import React, { useState } from "react";
import Slider from "react-slick";

import { IData } from "features/offers/offers.interface";
import Timer from "../../timer/Timer";
import viewallIcon from "assets/icons/viewall-arrow.png";

import "./OddCarousel.scss";
import { DirectionCheck } from "utils/classnameSwitch";
import OfferCard from "../../OfferCard/OfferCard";

const OddCarouselComponent: React.FC<IData> = ({ offers, title, hasTimer }) => {
  const [expiryTimestamp, setExpiryTimestamp] = useState(new Date(offers[0]?.expiry || "").getTime());
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "0",
    variableWidth: true,
    prevArrow: (
      <div>
        <button
          className="carousel-arrow carousel-arrow-left"
          type="button"
        >
          <img src={viewallIcon} alt="view all" ></img>
        </button>
      </div>
    ),
    nextArrow: (
      <div>
        <button
          className="carousel-arrow carousel-arrow-right"
          type="button"
        >
          <img src={viewallIcon} alt="view all" ></img>
        </button>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          variableWidth: false,
        },
      },
    ],
    afterChange: (index: number) => setExpiryTimestamp(new Date(offers[index]?.expiry || "").getTime())
  };

  return (
    <>
      <h3 className="layout-grid offer-sections-header" dir={DirectionCheck()}>
        {title} <Timer expiryTimestamp={expiryTimestamp} />
      </h3>
      <div className={`carousel-wrapper odd-carousel ${offers.length === 1 ? 'single-odd': ''}`}>
        <Slider {...carouselSettings}>
          {
            offers.map((data, key) => {
              return <OfferCard data={data} variant="odd-carousel" key={key} />;
            })
          }
        </Slider>
      </div>
    </>
  );
};

export default OddCarouselComponent;
